import React from "react";

const Case = () => {
  return <div>This is case</div>;
};

export default Case;
